import React, { createElement } from 'react';
import { render, unmountComponentAtNode } from 'react-dom';
import { filter, each } from 'lodash';

export function mountAll(Components) {
  const mounted = [];

  filter(Components, 'tagName').forEach(Component =>
    each(window.document.getElementsByTagName(Component.tagName), container => {
      const options = {
        container,
        innerHTML: container.innerHTML,
      }
      mounted.push(options);
      if (Component.propsFromServer) {
        getPropsFromServer(container.id).then(props =>
          render(createElement(Component, {...options, ...props}), container)
        );
      } else {
        render(createElement(Component, options), container);
      }
    })
  );

  return function unmount() {
    mounted.forEach(({ container, innerHTML }) => {
      unmountComponentAtNode(container);
      container.innerHTML = innerHTML;
    });
  }
}

const cache = {}
function getPropsFromServer(blockId) {
  if (!cache[blockId]) {
    cache[blockId] = window.fetch(`?fetchVars=1&blockId=${blockId}`).then(res => res.json());
  }
  return cache[blockId];
}

export function mount(options, Component) {
  if (typeof options == 'string') {
    options = { tagName: options }
  }
  Component.tagName = options.tagName;
  Component.propsFromServer = options.propsFromServer;
  return Component;
}
